<div class="accordion" [class.accordion--expanded]="expanded()">
    <div class="accordion__header" (click)="toggleExpansion()">
        <div class="accordion__header-content">
            <div class="accordion__header-left" (click)="$event.stopPropagation()">
                @if (showToggle()) {
                    <ntv-toggle-button [checked]="isChecked()" (checkedChange)="onToggle($event)" />
                }
            </div>

            <div class="accordion__header-main">
                <div class="accordion__header-title">
                    <ng-content select="[header-title]"></ng-content>
                </div>
                <div class="accordion__header-description">
                    <ng-content select="[header-description]"></ng-content>
                </div>
            </div>

            <div class="accordion__header-right">
                <div class="accordion__header-top">
                    <div
                        class="accordion__chevron"
                        [class.accordion__chevron--expanded]="expanded()"
                        [ngClass]="iconTwColor()">
                        <svg width="14" height="14">
                            <use xlink:href="assets/icons/icons-sprite.svg#chevron"></use>
                        </svg>
                    </div>
                </div>
                <div class="accordion__header-bottom">
                    <ng-content select="[header-bottom]"></ng-content>
                </div>
            </div>
        </div>
    </div>

    <div
        class="accordion__body"
        [style.max-height]="expanded() ? '2000px' : '0'"
        [class.accordion__body--expanded]="expanded()">
        <div class="accordion__body-content" [style.padding]="padding()">
            <ng-content></ng-content>
        </div>
    </div>
</div>
